import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * When the URL has a hash (e.g. arriving from /legal → /#how-it-works),
 * scroll to that element after the route mounts.
 */
export default function ScrollToHash() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) {
            // Only reset scroll when entering a new route with no hash and not on same path.
            window.scrollTo({ top: 0, behavior: "auto" });
            return;
        }
        // Wait a tick for DOM.
        const id = hash.slice(1);
        const t = setTimeout(() => {
            const el = document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
        return () => clearTimeout(t);
    }, [pathname, hash]);
    return null;
}
